'use client';

import { useCallback, useState } from 'react';

export interface UseRecaptchaV2Token {
    token: string | null;
    onChange: (token: string | null) => void;
    reset: () => void;
    resetKey: number;
}

/**
 * Holds the reCAPTCHA v2 token for a form. Pass `onChange` to <RecaptchaV2Checkbox>, read
 * `token` at submit time, and after a failed submit call `reset()` and spread
 * `key={resetKey}` onto the checkbox to mount a fresh widget.
 */
export function useRecaptchaV2Token(): UseRecaptchaV2Token {
    const [token, setToken] = useState<string | null>(null);
    const [resetKey, setResetKey] = useState(0);

    const reset = useCallback(() => {
        setToken(null);
        setResetKey((key) => key + 1);
    }, []);

    return { token, onChange: setToken, reset, resetKey };
}
